
	const AcceptTokenGenerator = require("./AcceptTokenGenerator");
	const TokenHandler = require("./TokenHandler");

/* ======================================================================
	Save Card Type on Change
	===================================================================== */

	$('[data-anet-name="cardNumber"]').on("change", function() {
		var cardType = gformFindCardType($(this).val());
		$('[data-anet-name="cardType"]').val(cardType);
	})

/* ======================================================================
	Obfuscate and Save Some Card Data
	===================================================================== */

	var obfuscateCardInput = function(form) {
		var value = $(form).find('[data-anet-name="cardNumber"]').val();
		$(form).find('[data-anet-name="cardNumber"]').val(value.slice(-4));
	}

/* =====================================================================
	Error Processing
	==================================================================== */

	const unset_gf_submission_flag = function(form) {
		var form_id                 = $(form).attr("id");
		var gf_submission_flag_name = form_id.replace("gform_", "gf_submitting_");

		window[gf_submission_flag_name] = false;
	}

	const set_cc_gf_error = function(form, error_message) {
		var $error = $(form).find(".validation_message");

		if (!$error.length) {
			$(form).append('<div class="gfield_description validation_message">' + error_message + ' </div>')
		}

		$error.text(error_message);
	}

	const setTokenErrors = function(error) {
		unset_gf_submission_flag(this);
		set_cc_gf_error(this, error)
	}

/* ======================================================================
	Verify Credit Card For Server Side Processing
	===================================================================== */



	const removeTokenGeneratorListener = function() {
		$(document).off("submit", ".acceptjs-form", submitWithToken);
		unset_gf_submission_flag(this);

		obfuscateCardInput(this);

		this.submit();
	}

	const generateTokenOnSubmission = function(form) {
		const generator   = new AcceptTokenGenerator(ANET.CLIENT_KEY, ANET.API_LOGIN_ID);
		const tokenSetter = new TokenHandler(form);

		generator.formRoot = form;
		generator.on("generatedToken", tokenSetter.responeHandler.bind(tokenSetter));
		generator.on("tokenGenerationFailed", setTokenErrors.bind(form));

		generator.buildCardData();

		try {
			generator.generateToken();
		} catch (error) {
			setTokenErrors.bind(form)("Please fill out all required fields");
		}

		tokenSetter.on("tokenSet", removeTokenGeneratorListener.bind(form));
	}

/* ======================================================================
	Generate Token on Form Submission
	===================================================================== */

	const submitWithToken = function(event, isFormSectionSubmission) {
		if (isFormSectionSubmission) {
			return;
		}

		event.preventDefault();
		generateTokenOnSubmission(this);
	}

	$(document).on("submit", ".acceptjs-form", submitWithToken);
